const LastConnectedWalletKey = 'ktn_last_connected_wallet';

export enum WalletsType {
  MultiversX = 'MultiversX',
  MetaMask = 'MetaMask',
  Other = 'Other',
}

export const SetLastConnectedWallet = (wallet: WalletsType) => {
  localStorage.setItem(LastConnectedWalletKey, wallet);
};

export const GetLastConnectedWallet = (): WalletsType => {
  const res = localStorage.getItem(LastConnectedWalletKey);

  if (res) {
    return res as WalletsType;
  }
  return WalletsType.MetaMask;
};
